import React from 'react';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {useDeleteAgencyMutation} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useTranslation} from '../../hooks/useTranslation';
const AgencyDeleteModal = ({exit, currentFBO, getAgencies}) => {
  const dispatch = useDispatch();
  const [deleteAgency, {isLoading, isError, error, data, isSuccess}] =
    useDeleteAgencyMutation();
  const errorHandler = useErrorHandler([error]);
  const {t} = useTranslation();
  return (
    <div className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('agencyDeleteModal.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div
          className='modal__content-body'
          style={{display: 'flex', justifyContent: 'center'}}
        >
          {t('agencyDeleteModal.message')}
        </div>
        <div className='modal__content-bottom'>
          <button
            className='save danger '
            onClick={() => {
              dispatch(setLoader(true));
              deleteAgency(currentFBO.id)
                .then(res => {
                  dispatch(setLoader(false));
                  toast.success(res.data.message);
                  exit();
                  getAgencies();
                })
                .catch(err => {
                  dispatch(setLoader(false));
                  exit();
                });
            }}
          >
            {t('agencyDeleteModal.delete')}
          </button>
          <button className='close almost' onClick={exit}>
            {t('agencyDeleteModal.cancel')}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
};

export default AgencyDeleteModal;
